<template>
<v-dialog v-model="seriesDialog" max-width="750">
  <v-card>
    <v-card-title class="border-bottom">
      Seri Listesi - {{this.stockCode}}
      <v-spacer></v-spacer>
      <v-btn @click="closeSeriesDialog()" color="danger darken-1" style="color:white;" >
        KAPAT
      </v-btn>
    </v-card-title>
    <v-card-text>
      <b-table
          hover
          small
          responsive
          sort-icon-left
          head-row-variant="info"
          style="font-size:12px;"
          table-variant="white"
          show-empty
          :items="seriesList"
          :fields="seriesListHeaders"
          :busy="seriesListLoading"
      >
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{scope.loading ? "Lütfen Bekleyin" : "Veri Bulunamadı"}}
          </h6>
        </template>
      </b-table>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
import { mapState} from "vuex";

export default {
  name: "CurrentActionDetailsSeriesDialog",
  props: {
    showSeriesDialog: {
      type: Boolean,
      required: true
    },
    stockCode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      seriesDialog: false
    };
  },
  methods: {
    closeSeriesDialog() {
      this.seriesDialog = false;
    }
  },
  computed: {
    ...mapState("current", ["seriesList","seriesListLoading","seriesListHeaders"])
  },
  watch: {
    seriesDialog: function(newVal) {
        this.$emit("seriesDialogChange", newVal);
    },
    showSeriesDialog: function (newVal) {
      this.seriesDialog = newVal;
    }
  }
}
</script>
<style scoped>

</style>